export enum AppStatus {
  INITIAL = 'INITIAL',
  PAUSED = 'PAUSED',
  RESUMED = 'RESUMED'
}
